import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as PopOut } from '@pkg/assets/icons/v2/pop-out.svg';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';
import config from '@app/config';

import './_OpenYat.scss';

interface OpenYatProps {
    emojiId: EmojiId;
    iconSize?: string;
}

const OpenYat = ({ emojiId, iconSize }: OpenYatProps) => {
    const { t } = useTranslation(['words']);

    return (
        <a
            href={`${window.location.protocol}//${config.publicUrl}/${emojiId}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('share')}
            className={`open-yat-button ${iconSize}`}
        >
            <PopOut aria-hidden="true" />
        </a>
    );
};
export default OpenYat;
